<template>
    <span class="item-card" :class="{ active }" ref="voucherCard">
        <span class="item-selected">
            <IconSvg filepath="tick.svg" class="tick-svg" />
        </span>
        <span class="image-wrapper">
            <ImageFluid
                :src="voucherImage.image.small"
                :alt="voucherImage.image.altText"
                eager
                img-class="item-image"
                width="300"
                height="166"
            />
        </span>
        <span class="item-title">{{ voucherImage.title }}</span>
        <span class="item-description">{{ voucherImage.description }}</span>
    </span>
</template>

<script>
import ImageFluid from '../ImageFluid';

export default {
    name: 'VoucherImageCard',
    components: { ImageFluid },
    props: {
        voucherImage: {
            type: Object,
            required: true
        },
        active: Boolean
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use 'sass:map';

.item-card {
    background-color: var(--white);
    &:after {
        background-color: var(--white);
    }

    border: 1px solid var(--inputs-empty-border-color);
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    z-index: 0;
    width: 100%;
    justify-content: space-between;

    &:not(.swiper-slide) {
        &:after {
            content: '';
            position: absolute;
            z-index: -1;
            width: 100%;
            height: 100%;
            opacity: 0;
            box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
                0 3px 1px -2px rgba(0, 0, 0, 0.12);
            transition: opacity 0.15s ease-in-out;
        }
    }

    &.active,
    &.swiper-slide-active.swiper-slide-duplicate {
        border: 1px solid map.get(variables.$inputs, 'filled-color');

        .item-selected {
            opacity: 1;
        }
    }
}

.item-selected {
    background-color: map.get(variables.$inputs, 'filled-color');
    border-radius: 50%;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
    opacity: 0;
    position: absolute;
    right: 5%;
    top: 5%;
    transition: opacity 0.15s ease-in-out;
    z-index: 10;

    .tick-svg {
        color: var(--white);
        height: 1em;
        margin: 0.5em;
        width: 1em;
    }
}

.image-wrapper {
    padding-top: 55%; //aspect-ratio doesn't work in older Safari
    position: relative;
    margin-bottom: 1rem;
    top: 0;

    ::v-deep .item-image {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        height: 100%;
        width: 100%;
    }
}

.item-title {
    color: var(--primary);
    display: block;
    padding: 0 1rem 0.5rem;
    text-transform: uppercase;
    font-weight: bold;
}

.item-description {
    display: block;
    flex: 1;
    font-weight: 400;
    padding: 0 1rem 1rem;
}

@include variables.ie {
    .item-select {
        clip: rect(1px, 1px, 1px, 1px);
    }

    ::v-deep .item-image {
        flex-shrink: 0;
        max-width: 100%;
    }

    .item-description {
        flex: 1 1 auto;
    }
}
</style>
